import type { ReactNode } from 'react';

export const symbol_eraser_size_5: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M400-120q-117 0-198.5-81.5T120-400q0-54 20.5-104.5T202-597l162-162q41-41 92-61t105-20q116 0 197.5 81.5T840-561q0 54-20 105t-61 92L597-202q-42 41-92.5 61.5T400-120Z"
		/>
	</svg>
);
